import * as Sentry from '@sentry/react';
import React from 'react';
import { getApplicationEnv } from '..';
import { ErrorBoundary } from './component';
import { SentryConfig } from './sentryConfig';

export interface SentryInstance {
    initialize(): void;
    ErrorBoundary: React.ComponentType<{ children: React.ReactNode }>;
}

/**
 * Creates a Sentry instance. If config is null, returns a no-op instance
 * that skips initialization but provides a passthrough ErrorBoundary.
 */
export function createSentry(config: SentryConfig | null): SentryInstance {
    if (!config) {
        return {
            initialize() {
                console.info('[Sentry] DSN not configured, skipping initialization');
            },
            // Passthrough component when Sentry is disabled
            ErrorBoundary: ({ children }) => React.createElement(React.Fragment, null, children),
        };
    }

    return {
        initialize() {
            Sentry.init({
                environment: getApplicationEnv(),
                ignoreErrors: ['ResizeObserver loop limit exceeded'],
                integrations: [Sentry.browserTracingIntegration()],
                ...config,
            });
        },
        ErrorBoundary,
    };
}
